if (!customElements.get('donavant-hero-media')) {
  customElements.define('donavant-hero-media', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.soundButton = this.querySelector('[data-sound-toggle]');
      this.playButton = this.querySelector('[data-play-toggle]');
      if (!this.video || !this.soundButton || this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = this.reducedMotion;
      this.playAttempt = 0;
      this.video.controls = false;
      this.video.muted = false;
      try { this.video.muted = sessionStorage.getItem('donavant-film-muted') === 'true'; } catch (_) {}
      this.querySelector('[data-media-controls]').hidden = false;
      this.soundButton.addEventListener('click', () => {
        ++this.playAttempt;
        if (this.video.paused) {
          this.video.muted = false;
          this.userPaused = false;
          this.tryPlay();
        } else {
          this.video.muted = !this.video.muted;
        }
        try { sessionStorage.setItem('donavant-film-muted', String(this.video.muted)); } catch (_) {}
        this.updateControls();
      }, options);
      this.playButton.addEventListener('click', () => {
        ++this.playAttempt;
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause();
        else this.tryPlay();
        this.updateControls();
      }, options);
      ['play', 'pause', 'volumechange', 'error'].forEach(event => this.video.addEventListener(event, () => this.updateControls(), options));
      this.updateControls();
      if (!this.reducedMotion) this.start();
    }

    async start() {
      const attempt = ++this.playAttempt;
      try {
        await this.video.play();
      } catch (_) {
        if (!this.isConnected || attempt !== this.playAttempt || this.userPaused) return;
        this.video.muted = true;
        try { await this.video.play(); } catch (_) { /* The visible play control remains available. */ }
      }
      if (this.isConnected) this.updateControls();
    }

    tryPlay() {
      const playback = this.video.play();
      if (playback) playback.catch(() => this.updateControls());
    }

    updateControls() {
      const paused = this.video.paused;
      const muted = this.video.muted || this.video.volume === 0;
      this.dataset.sound = muted || paused ? 'off' : 'on';
      this.dataset.playback = paused ? 'paused' : 'playing';
      this.soundButton.querySelector('[data-sound-label]').textContent = paused ? 'Play with sound' : muted ? 'Sound on' : 'Mute sound';
      this.soundButton.setAttribute('aria-label', paused ? 'Play film with sound' : muted ? 'Turn video sound on' : 'Mute video');
      this.playButton.setAttribute('aria-label', paused ? 'Play film' : 'Pause film');
      this.playButton.hidden = paused;
    }

    disconnectedCallback() {
      ++this.playAttempt;
      this.events?.abort();
      this.events = null;
    }
  });
}
